import { tripSheetCommunicationTypes } from "helpers/enums/tripSheetCommunicationTypes";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { namesList as driverNamesList } from "sources/books/drivers";
import { list as legalPersonsList } from "sources/books/legalPersons";
import { numbersList as trailerNumbersList } from "sources/books/trailers";
import { numbersList as truckNumbersList } from "sources/books/trucks";

const defaultTransportationKind =
    "Перевозка грузов на основании договора перевозки грузов или договора фрахтования (в т.ч. по договору аренды транспортного средства с экипажем)";

const config = {
    // --- Основное ---
    legalPersonId: {
        label: "Юридическое лицо",
        inputProps: { name: "legalPersonId" },
        url: legalPersonsList,
        propName: "name",
        menuPortalTarget: document.body,
    },
    validFrom: {
        label: "Срок действия: начало",
        inputProps: { name: "validFrom" },
        required: true,
        validators: [requiredField],
    },
    validTo: {
        label: "Срок действия: конец",
        inputProps: { name: "validTo" },
        required: true,
        validators: [requiredField],
    },
    documentDate: {
        label: "Дата документа",
        inputProps: { name: "documentDate" },
    },
    communicationType: {
        label: "Вид сообщения",
        inputProps: { name: "communicationType" },
        options: tripSheetCommunicationTypes,
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
    },
    transportationKind: {
        label: "Вид перевозок",
        inputProps: { name: "transportationKind" },
        textarea: true,
    },
    dispatcherComment: {
        label: "Комментарий диспетчера",
        inputProps: { name: "dispatcherComment" },
        textarea: true,
    },
    noAssignmentReason: {
        label: "Причина рейса без заявки",
        inputProps: { name: "noAssignmentReason" },
        textarea: true,
    },
    changeReason: {
        label: "Причина изменения или повторного включения заявки",
        inputProps: { name: "changeReason" },
        textarea: true,
    },

    // --- Сцепка ---
    driverId: {
        label: "Водитель 1",
        inputProps: { name: "driverId" },
        url: driverNamesList,
        propName: "fullName",
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
    },
    secondaryDriverId: {
        label: "Водитель 2",
        inputProps: { name: "secondaryDriverId" },
        url: driverNamesList,
        propName: "fullName",
        menuPortalTarget: document.body,
    },
    isCrew: {
        label: "Экипаж",
        inputProps: { name: "isCrew" },
    },
    carId: {
        label: "Госномер ТС",
        inputProps: { name: "carId" },
        url: truckNumbersList,
        propName: "number",
        required: true,
        validators: [requiredField],
        menuPortalTarget: document.body,
    },
    trailerId: {
        label: "Госномер прицепа",
        inputProps: { name: "trailerId" },
        url: trailerNumbersList,
        propName: "number",
        menuPortalTarget: document.body,
    },

    // --- Работа ТС ---
    plannedDepartureAt: {
        label: "Выезд из гаража (плановое)",
        inputProps: { name: "plannedDepartureAt" },
    },
    actualDepartureAt: {
        label: "Выезд из гаража (фактическое)",
        inputProps: { name: "actualDepartureAt" },
    },
    odometerValueOnDeparture: {
        label: "Одометр при выезде (км)",
        inputProps: { name: "odometerValueOnDeparture", type: "number", min: 0 },
    },
    plannedReturnAt: {
        label: "Возвращение в гараж (плановое)",
        inputProps: { name: "plannedReturnAt" },
    },
    actualReturnAt: {
        label: "Возвращение в гараж (фактическое)",
        inputProps: { name: "actualReturnAt" },
    },
    odometerValueOnReturn: {
        label: "Одометр при возвращении (км)",
        inputProps: { name: "odometerValueOnReturn", type: "number", min: 0 },
    },
    departureOdometerCorrectionReason: {
        label: "Причина корректировки одометра при выезде",
        inputProps: { name: "departureOdometerCorrectionReason" },
        textarea: true,
    },
    returnOdometerCorrectionReason: {
        label: "Причина корректировки одометра при возвращении",
        inputProps: { name: "returnOdometerCorrectionReason" },
        textarea: true,
    },
    mileageDiscrepancyReason: {
        label: "Причина расхождения общего пробега и пробега смен",
        inputProps: { name: "mileageDiscrepancyReason" },
        textarea: true,
    },

    // --- Топливо ---
    issuedLiters: {
        label: "Выдано горючего (л)",
        inputProps: { name: "issuedLiters", type: "number", min: 0, step: "0.01" },
    },
    issuedCorrectionReason: {
        label: "Причина корректировки выданного горючего",
        inputProps: { name: "issuedCorrectionReason" },
        textarea: true,
    },
    balanceDepartureLiters: {
        label: "Остаток при выезде (л)",
        inputProps: { name: "balanceDepartureLiters", type: "number", min: 0, step: "0.01" },
    },
    balanceDepartureCorrectionReason: {
        label: "Причина корректировки остатка при выезде",
        inputProps: { name: "balanceDepartureCorrectionReason" },
        textarea: true,
    },
    refilledOnRouteLiters: {
        label: "Заправлено в пути (л)",
        inputProps: { name: "refilledOnRouteLiters", type: "number", min: 0, step: "0.01" },
    },
    refilledOnRouteCorrectionReason: {
        label: "Причина корректировки заправленного в пути",
        inputProps: { name: "refilledOnRouteCorrectionReason" },
        textarea: true,
    },
    balanceReturnLiters: {
        label: "Остаток при возвращении (л)",
        inputProps: { name: "balanceReturnLiters", type: "number", min: 0, step: "0.01" },
    },
    balanceReturnCorrectionReason: {
        label: "Причина корректировки остатка при возвращении",
        inputProps: { name: "balanceReturnCorrectionReason" },
        textarea: true,
    },
    normChangeCoefficient: {
        label: "Коэффициент изменения нормы",
        inputProps: { name: "normChangeCoefficient", type: "number", step: "0.01" },
    },

    // --- Ответственные ---
    mechanicName: {
        label: "Механик",
        inputProps: { name: "mechanicName" },
    },
    dispatcherName: {
        label: "Диспетчер",
        inputProps: { name: "dispatcherName" },
    },
    taxerName: {
        label: "Таксировщик",
        inputProps: { name: "taxerName" },
    },
    controllerName: {
        label: "Контроллер",
        inputProps: { name: "controllerName" },
    },

    // --- Осмотры ---
    preTripInspectionAt: {
        label: "Дата предрейсового осмотра",
        inputProps: { name: "preTripInspectionAt" },
    },
    medicalWorkerName: {
        label: "Медицинский работник",
        inputProps: { name: "medicalWorkerName" },
    },
    medicalExamAt: {
        label: "Дата медосмотра",
        inputProps: { name: "medicalExamAt" },
    },
    medicalMarksConfirmedOnPaper: {
        label: "Обязательные медицинские отметки есть на бумажном оригинале",
        inputProps: { name: "medicalMarksConfirmedOnPaper" },
    },
    technicalInspectionConfirmedOnPaper: {
        label: "Отметка технического контроля есть на бумажном оригинале",
        inputProps: { name: "technicalInspectionConfirmedOnPaper" },
    },
};

const initialState = {
    ...getInitialStateFromConfig(config),
    transportationKind: defaultTransportationKind,
    isCrew: false,
    medicalMarksConfirmedOnPaper: false,
    technicalInspectionConfirmedOnPaper: false,
};

export { config, initialState };
